// VideoSection.js

function VideoSection() {
  return (
    <section className="video-section">
      <div className="video-content">

        <div className="section-header">
          <div className="contact-eyebrow">Our Story</div>
          <h2>Watch Our <span>Story</span></h2>
          <p>
            Discover how we're transforming media and community relations at the
            University of Peradeniya
          </p>
        </div>

        <div className="video-container">
          <div className="video-wrapper">
            <video controls poster="/videothumbnail.jpg">
              <source src="/MediaUnit.mp4" type="video/mp4" />
              <source src="/MediaUnit.webm" type="video/webm" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>

      </div>
    </section>
  );
}

export default VideoSection;